import { Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"

interface EmptyAdvertisementProps {
  additionalStyling?: object
}

export default function EmptyAdvertisement({
  additionalStyling,
}: EmptyAdvertisementProps) {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden",
        // border: "1px solid white",
        // height: "80%",
        backgroundColor: "#E0E6ED",
        justifyContent: "end",
        cursor: "pointer",
        ...additionalStyling,
      }}
      onClick={() => {
        navigate("/about-us")
      }}
    >
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#B0B8C1",
          paddingY: 2,
          justifyContent: "center",
          alignContest: "center",
        }}
      >
        <Typography textAlign="center">
          Contact us to host your own advertisement here!
        </Typography>
      </Box>
    </Box>
  )
}
